.hide-before-scroll{
    display: none !important;
}

.show-after-scroll{
    animation: fadeIn 0.25s;
    display: block;
}

@keyframes fadeIn {
    0% { opacity: 0; }
    100% { opacity: 1; }
}

:root {
    color: green;
}
